import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import * as PIXI from 'pixi.js'

@Component({
    selector: 'app-image-upload',
    templateUrl: 'image-upload.component.html',
    styleUrls: ['image-upload.component.scss'],
    standalone: false
})
export class ImageUploadComponent implements AfterViewInit {
  app!: PIXI.Application

  @ViewChild('container')
  container!: ElementRef

  @Output()
  onImage = new EventEmitter<{ url: string; blob: Blob }>()

  @Input()
  width!: number

  @Input()
  height!: number

  imgUrl!: string

  constructor() {}

  async ngAfterViewInit() {
    this.app = new PIXI.Application()
    await this.app.init({ width: this.width, height: this.height, antialias: true })
    this.container.nativeElement.appendChild(this.app.canvas)
  }

  async fileSelected(fileList: FileList) {
    if (fileList.length > 0) {
      const file = fileList[0]

      if (this.imgUrl) {
        URL.revokeObjectURL(this.imgUrl)
      }

      this.imgUrl = URL.createObjectURL(file)
     
      const asset = await PIXI.Assets.load({src: this.imgUrl, loadParser: 'loadTextures'})
      const texture = PIXI.Sprite.from(asset)
      const { width: imgWidth, height: imgHeight } = texture
      const imgRatio = imgWidth / imgHeight
      const imgScale = imgRatio > 1 ? imgWidth / this.width : imgHeight / this.height
      const imgScaleFactor = 1 / imgScale

      console.log(`img size w: ${imgWidth} h: ${imgHeight} ratio ${imgRatio}`)
      console.log(`bounding box (${this.width}, ${this.height}) and scaling factor ${imgScaleFactor}`)

      texture.scale.set(imgScaleFactor)
      // img.width = imgWidth * imgScaleFactor
      // img.height = imgHeight * imgScaleFactor

      this.app.stage.removeChildren()
      this.app.stage.addChild(texture)

      this.emitImage()
    }
  }

  private emitImage() {
    // wait a little until stage is rendered and try to extract after the data
    setTimeout(() => {
      console.log(this.app.renderer)
      this.app.renderer.extract.canvas(this.app.stage).toBlob((b: Blob) => {
        const url = URL.createObjectURL(b)
        this.onImage.emit({ url, blob: b })
      })
    }, 100)
  }
}
